import { render } from "./DesignDetailPage.vue?vue&type=template&id=0a04d291&scoped=true"
import script from "./DesignDetailPage.vue?vue&type=script&lang=js"
export * from "./DesignDetailPage.vue?vue&type=script&lang=js"

import "./DesignDetailPage.vue?vue&type=style&index=0&id=0a04d291&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a04d291"]])

export default __exports__